import { CallResult } from '../../../Api/APIService';
import { FinancialEditPayload } from './EditModal/financialEditHelpers';
import { DetailPanel, DetailPanelParams, DetailPanelEntity } from './DetailPanel';

export interface DetailPanelContainerParams {
  data: DetailPanelParams[];
  invalidFields?: string[];
  saveAction?: (
    data: DetailPanelEntity | FinancialEditPayload
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ) => Promise<CallResult<any>>;
  dataTestId?: string;
}

export const DetailPanelContainer = ({ data, saveAction, dataTestId, invalidFields }: DetailPanelContainerParams) => {
  return (
    <div data-testid={dataTestId || 'detail-panel-container'}>
      {data.map((d, i) => (
        <DetailPanel
          key={i}
          data={d.data}
          canEdit={d.canEdit}
          fieldMap={d.fieldMap}
          order={d.order}
          saveAction={saveAction}
          links={d.links}
          associationNameFields={d.associationNameFields}
          invalidFields={invalidFields}
        />
      ))}
    </div>
  );
};
